import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import constants from "@/constants";
import Agent from "@/models/Agent/Agent";

export default class Status extends BossModel {

    static apiUrl = 'agent/product/status';

    static entity = 'agentProductStatuses';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_product_id: this.number(null).nullable(),
            status_cid: this.number(null).nullable(),
            agent_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            travalco_booking_eid: this.attr(null),
            travalco_error: this.attr(null),
            created_at: this.attr(null),
            comments: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            agent: this.belongsTo(Agent, 'agent_id'),
        }
    }

    StatusProps() {
        return Object.values(constants.agentStatuses).find(item => item.id === this.status_cid)
    }

    Name() {
        return this.StatusProps().label;
    }

    Color() {
        return this.StatusProps().color;
    }

    get locked() {
        return this.IsConfirmed() || this.IsRequested();
    }

    IsNotRequested() {
        return this.status_cid === constants.agentStatuses.notRequested.id;
    }

    IsRequested() {
        return this.status_cid === constants.agentStatuses.requested.id;
    }

    IsConfirmed() {
        return this.status_cid === constants.agentStatuses.confirmed.id;
    }

    IsDenied() {
        return this.status_cid === constants.agentStatuses.denied.id;
    }
}
